<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">学生实训计划成绩</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <el-tag>{{$refs.organDia?$refs.organDia.nodeArrName:''}}</el-tag>&nbsp;<el-button type="primary" @click="dialogOpen">选择</el-button>
        </el-form-item> -->
        <!-- <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:400px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="实训计划名称">
          <el-input v-model="formInline.plan_name" clearable placeholder="请输入实训计划名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <!-- <custom-table-column prop="number" label="编号" width="120">
        </custom-table-column> -->
        <custom-table-column fixed prop="name" label="学生姓名" width="120">
        </custom-table-column>
        <custom-table-column fixed prop="plan_name" label="实习计划名称" min-width="180">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="院系" width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" width="160">
        </custom-table-column>
        <custom-table-column prop="class_name" label="班级" width="160">
        </custom-table-column>
        <custom-table-column label="是否打分" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.score" style="color:var(--ligtGreen);">是</span>
            <span v-else style="color:var(--red);">否</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="scoreList" width="300" label="打分情况">
          <template slot-scope="scope">
            <div v-if="scope.row.scoreList">
              <span v-for="item in scope.row.scoreList" :key="item.id">{{item.item}}:{{item.score}};</span>
            </div>
          </template>
        </custom-table-column>
        <custom-table-column prop="teacher" label="指导老师" width="120">
        </custom-table-column>
        <custom-table-column prop="totalScore" label="总分" width="120">
        </custom-table-column>
        <!-- <custom-table-column prop="buy_at" label="开始时间" width="160">
          <template slot-scope="scope">
            <span>{{scope.row.buy_at? $until.getTimeStr(new Date(scope.row.buy_at).getTime() / 1000,'-'):''}}</span>
          </template>
        </custom-table-column> -->
        <!-- <custom-table-column prop="total_price" label="总价" width="180">
        </custom-table-column> -->
        <!-- <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column> -->
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="编号" prop="number">
          <el-input v-model="ruleForm.number" placeholder="请输入编号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实训耗材名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入实训耗材名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="数  量" prop="quantity">
          <el-input v-model.number="ruleForm.quantity" placeholder="请输入数量" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="价  格" prop="price">
          <el-input v-model.number="ruleForm.price" placeholder="请输入价格" style="width:198px;"></el-input> 元
        </el-form-item>
        <el-form-item label="购买时间" prop="buy_at">
          <el-date-picker type="datetime" placeholder="选择购买时间" v-model="ruleForm.buy_at" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="总  价" prop="total_price">
          <el-input v-model.number="ruleForm.total_price" placeholder="请输入总价" style="width:198px;"></el-input> 元
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteTarinRoom">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    
    return {
      formInline: {
        structure_1: '',
        major: '',
        class_name: '',
        plan_name: '',
      },
      levell:[1,2,3],
      organLabel: '',
      ruleForm: {
        number: 0,
        name: '',
        quantity: 0,
        price: 0,
        total_price: 0,
      },
      ruleFormTep: {
        number: 0,
        name: '',
        quantity: 0,
        price: 0,
        total_price: 0,
      },
      rules: {
        number: [
          { required: true, message: '编号不能为空' },
          { type: 'number', message: '编号必须为数字值' },
        ],
        quantity: [
          { required: true, message: '数量不能为空' },
          { type: 'number', message: '数量必须为数字值' },
        ],
        price: [
          { required: true, message: '价格不能为空' },
          { type: 'number', message: '价格必须为数字值' },
        ],
        total_price: [
          { required: true, message: '总价不能为空' },
          { type: 'number', message: '总价必须为数字值' },
        ],
        name: [{ required: true, message: '请输入实训耗材名称', trigger: 'blur' }],
        buy_at: [{ type: 'date', required: true, message: '请选择购买时间', trigger: 'change' }],
      },
    };
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async deleteTarinRoom() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteConsumeInto(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createTarinRoom() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      if (params.buy_at) {
        let timee = params.buy_at.getTime() / 1000;
        params.buy_at = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.creat.createConsumeInto(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateTarinRoom() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let timee = '';
      if (typeof params.buy_at == 'string') {
        timee = new Date(params.buy_at).getTime() / 1000;
        params.buy_at = this.$until.getTimeStr(timee, '-');
      } else {
        timee = params.buy_at.getTime() / 1000;
        params.buy_at = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.update.updateTarinRoom(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      if (this.selectNodeForQuery) {
        this.organLabel = this.selectNodeForQuery.structure_names || this.selectNodeForQuery.name;
        if(!this.selectNodeForQuery.level){
          return
        }
        let strArr = this.organLabel.split('-');
        this.formInline.structure_1 = strArr[0] ? strArr[0] : '';
        this.formInline.major = strArr[1] ? strArr[1] : '';
        this.formInline.class_name = strArr[2] ? strArr[2] : '';
      } else {
        this.formInline.structure_1 = '';
        this.formInline.major = '';
        this.formInline.class_name = '';
      }
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getStudentScores(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createTarinRoom();
          } else if (this.type == 'edit') {
            this.updateTarinRoom();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
